<template>
	<header-block :title="title" :border="image ? 0 : null" :bgcolor="image ? '#281C3Bff' : 'white'" :color="image ? 'white' : null"></header-block>

	<transition>
		<div class="head" v-if="filter && availableVouchers">
			<div class="header" :style="'background-image: url(' + image + ')'">
				<v-row>
					<v-col class="v-col-7 title-col">
						<h1>{{ title }}</h1>
					</v-col>
					<v-col class="v-col-5 chip-col">
						<v-chip color="white" variant="flat">{{ filterCount }} card(s)</v-chip>
					</v-col>
				</v-row>
			</div>
		</div>
	</transition>

	<transition>
		<div v-if="availableVouchers">
			<VoucherList :showFavourites="true" @favouriteToggled="(v) => { favouriteToggled(v); }" @onFilterApplied="(count) => { filterCount = count }" :categories="filter" :showAll="false" :vouchers="availableVouchers" :search="false" />
		</div>
	</transition>

	<div v-if="!favourites && !filter && activeCategories && availableVouchers">
		<!-- Parent div to allow odd/even css selectors -->
		<div>
			<div :class="'hubItemWrapper'" v-for="c in this.activeCategories" :key="c.id">
				<CategoryButton @click="navFilter({ title: c.pageTitle, filters: c.providerFilters, image: c.pageImage });"  :image="c.buttonImage" :title="c.buttonTitle" />
			</div>
		</div>
	</div>
	<div v-else>
		<div :class="'hubItemWrapper'" v-for="n in 8" :key="n">
			<v-skeleton-loader type="card" />
		</div>
	</div>

	<transition>
		<div v-if="favourites && favouriteVouchers && !filter" class="mt-2">
			<VoucherList :showFavourites="true" @favouriteToggled="(v) => { favouriteToggled(v); }" :vouchers="availableVouchers.filter(v => v.favourite)" :showAll="true" :search="false" />
		</div>
	</transition>

	<div style="clear:both; "></div>
	
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
import CategoryButton from './elements/CategoryButton.vue';

export default {
	mixins: [Services],
	components: {HeaderBlock, VoucherList, CategoryButton},
	data() {
		return {
			filter: this.$route.query.filters ?? null,
			filterCount: 0,
			title: this.$route.query.title ?? "Categories",
			image: this.$route.query.image ?? null,
			favourites: false,
			favouriteVouchers: null,
			activeCategories: null,
		}
	},
	methods: {
		onLoad: async function() {
			this._getCategories(() => {
				this.activeCategories = this.categories.filter(c => c.active);
			});
			this._getCustomer();
			this._getAvailableVouchers(() => {
				this.favouriteVouchers = this.availableVouchers.filter(v => v.favourite);
				this.availableVouchers.forEach(v => {
					this._removeUnavailableDiscountProviders(v);
				});
			});
			this._getCustomerVouchers();
		},
		navFilter: function(o) {
			this.$router.push({ path: '/vouchers', query: o });
		},
		gotoSearch: function() {
			this.$router.push({ path: '/vouchers/search' });
		},
		favouriteToggled: function(voucher) {
			if (voucher.favourite) {
				this._removeCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			} else {
				this._addCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			}
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.header {
	padding-top: 138px;
	background-size: cover;
	background-position: bottom;
	margin: -20px -30px 0px -30px;
	margin-top: -138px;
	color: white;
	p--adding-bottom: 200px;
	height: 300px;
	padding: 30px;
	padding-top: 200px;
	color: white;
	h1{
		font-size: 28px;
		margin-bottom: 15px;
	}
	margin-bottom: 40px;
}
.title-col {
	padding-top: 0px;
	padding-bottom: 20px;
}
.chip-col {
	text-align: right;
}

.topTabButton
{
	margin-top: 0px;
	text-transform: none;
	padding-top: 12px !important;
	padding-bottom: 23px !important;
	vertical-align: middle !important;
	background-color: #ffffff66 !important;
	font-weight: bold;
}

.topTabButton.selected {
    background-color: var(--text-color) !important;
	color: white !important;
}

.topMenuCol {
	padding-left: 3px;
	padding-right: 3px;
	margin-top: 0px;
	padding-top: 0px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-top: 0px;
	margin-bottom: 0px;
}

</style>
